import React from 'react';
import PropTypes from 'prop-types';
import { Serves } from './FoodItem.styles';

function FoodServes(props) {
    const { uom, serves } = props;

    return (
        uom !== 'people' &&
        serves && (
            <Serves
                sx={{
                    mt: 1,
                }}
                //variant="body2"
            >
                {serves.min === serves.max
                    ? serves.min > 1
                        ? `Serves ${serves.min}`
                        : ''
                    : `Serves ${serves.min} - ${serves.max}`}
            </Serves>
        )
    );
}

FoodServes.propTypes = {
    uom: PropTypes.string.isRequired,
    serves: PropTypes.object.isRequired,
};

export default FoodServes;
